import $ from 'jquery';

class Header {
    constructor(mobileBreakpoint) {
        this.$document = $(document);
        this.$window = $(window);
        this.speed = 200;

        // Header
        this.$header = $('.js-header');

        // Search
        this.$searchForm = $('.js-search');
        this.$searchOpenButton = $('.js-search-button');

        // Burger Menu
        this.$burgerButton = $('.js-burger-button');
        this.$burgerContent = $('.js-burger-content');
        this.$menuItemExpand = $('.js-menu-item-expand'); // Menu item expand button

        this.$heroLastBar = $('.js-hero-last-bar');

        this.$document.keyup((e) => {
            // Escape Key
            if (e.keyCode === 27) {
                this.resetEverything();
            }
        });

        // Bind events
        this.bindEvents();

        // Call function to handle scroll background change
        this.handleScroll();
    }

    bindEvents() {
        // Search Events
        this.$searchOpenButton.on('click', $.proxy(this.openSearch, this));

        // Burger Events
        this.$burgerButton.on('click', $.proxy(this.burgerToggle, this));

        // Menu Item Expand Events
        this.$menuItemExpand.on('click', $.proxy(this.toggleSubMenu, this));

        // Scroll Event
        this.$window.on('scroll', $.proxy(this.checkScrollPosition, this));

        // Change background color after a delay on load
        this.changeBackgroundColorOnLoad();
    }

    checkScrollPosition() {
        const scrollTop = this.$window.scrollTop();

        // Check if scrolled more than 200px
        if (scrollTop > 100) {
            this.$header.addClass('c-header--scrolled');
        } else {
            this.$header.removeClass('c-header--scrolled');
        }
    }

    handleScroll() {
        this.checkScrollPosition(); // Initial check on page load
    }

    openSearch() {
        this.$searchForm.toggleClass('is-visible');
    }

    closeSearch() {
        this.$searchForm.removeClass('is-visible');
    }

    burgerToggle() {
        this.$burgerButton.toggleClass('is-open');
        this.$header.toggleClass('is-open');
    }

    documentClick(e) {
        const $elem = $(e.target);
        // Close search if click is outside search form
        if (!$elem.closest(this.$searchForm).length && !$elem.closest(this.$searchOpenButton).length) {
            this.$searchForm.removeClass('is-visible');
        }
    }

    changeBackgroundColorOnLoad() {
        // Set a delay to change the left position variable
        setTimeout(() => {
            this.$heroLastBar.css('--after-left-position', 'auto'); // Change to `auto`
        }, 1000); // 1000ms delay (1 second)
    }

    resetEverything() {
        // Close
        this.closeSearch();

        // Reset Burger Menu
        this.$header.removeClass('is-open');
        this.$burgerButton.removeClass('is-open');
        this.$burgerContent.removeAttr('style');

        $('body').removeClass('is-scroll-locked');
    }
}

export default Header;
